import * as _ from 'lodash/fp';
import intersection from 'lodash/intersection';
import { ContextMenuOption } from '../context-menu-option.model';

export const intersectMenuOptions = (
  configurations: Array<ContextMenuOption[][] | undefined>,
): ContextMenuOption[][] => {
  const flatConfigurations = _.flowRight(
    _.map((configuration: ContextMenuOption[][][]) => _.flatten(configuration)),
    _.filter((configuration: Array<ContextMenuOption[][] | undefined>) => !!configuration),
  )(configurations);

  const sharedMenuOptions = intersection(...flatConfigurations);

  const used: ContextMenuOption[] = [];

  return _.flowRight(
    _.filter((optionGroup: ContextMenuOption[]) => !!optionGroup.length),
    _.reduce(
      (configuration: ContextMenuOption[][], optionGroup: ContextMenuOption[]) => [
        ...configuration,
        optionGroup.reduce((gAcc: ContextMenuOption[], option) => {
          if (sharedMenuOptions.includes(option) && !used.includes(option)) {
            gAcc.push(option);
            used.push(option);
          }
          return gAcc;
        }, []),
      ],
      [],
    ),
    _.filter((configuration: Array<ContextMenuOption[] | undefined>) => !!configuration),
    _.flatten,
  )(configurations) as ContextMenuOption[][];
};
